import React from 'react';

function InsightsScheduleCard() {
  return (
    <div style={styles.container}>
      <h3 style={styles.title}>Report Schedule</h3>
      <div style={styles.grid}>
        <div style={styles.item}>
          <div style={styles.iconWrap}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0E3293" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="5" width="18" height="14" rx="2"/>
              <polyline points="3,7 12,13 21,7"/>
            </svg>
          </div>
          <div>
            <strong style={styles.itemTitle}>Daily Report</strong>
            <p style={styles.itemDesc}>Every morning at 9:00 AM ET</p>
          </div>
        </div>
        <div style={styles.item}>
          <div style={styles.iconWrap}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0E3293" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
          </div>
          <div>
            <strong style={styles.itemTitle}>Weekly Report</strong>
            <p style={styles.itemDesc}>Every Monday at 9:00 AM ET</p>
          </div>
        </div>
      </div>
      <p style={styles.note}>
        Reports are emailed to all admins and stored in this dashboard.
      </p>
    </div>
  );
}

const styles = {
  container: {
    background: '#fff',
    border: '1px solid #e0e0e0',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '24px',
  },
  title: {
    margin: '0 0 16px',
    fontSize: '16px',
    color: '#333',
    fontWeight: '600',
  },
  grid: {
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
    marginBottom: '12px',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 16px',
    background: '#f8f9fa',
    borderRadius: '8px',
    flex: '1 1 200px',
  },
  iconWrap: {
    flexShrink: 0,
  },
  itemTitle: {
    display: 'block',
    color: '#333',
    fontSize: '14px',
    fontWeight: '600',
  },
  itemDesc: {
    margin: '2px 0 0',
    color: '#666',
    fontSize: '13px',
  },
  note: {
    margin: 0,
    color: '#888',
    fontSize: '13px',
    fontStyle: 'italic',
  },
};

export default InsightsScheduleCard;
